<template>
    <div class="main">
        <div class="body-content">
            <h1>General Excel Report</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <select id="partyname" v-model="newContainer.partyName" class="custom-select" style="width:100%">
                        <option value="0">Select Party</option>
                        <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                            {{ party.short_name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" style="width:100%" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" style="width:100%" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <select id="vesselName" v-model="newContainer.vesselID" class="custom-select" style="width:100%">
                        <option value="0">Select Vessel</option>
                        <option v-for="vessel in vessel" :key="vessel.Vesselid" :value="vessel.Vesselid">
                            {{ vessel.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="movementname">Movement Type *</label>
                    <select id="movementname" v-model="newContainer.movementID" class="custom-select"
                        style="width:100%">
                        <option value="0">Select Movement</option>
                        <option v-for="movement in movementOptions" :key="movement.Movid" :value="movement.Movid">
                            {{ movement.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <select id="location" v-model="newContainer.locID" class="custom-select" style="width:100%">
                        <option value="0">Select location</option>
                        <option v-for="location in location" :key="location.locationid" :value="location.locationid">
                            {{ location.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="vesselstatus">Vessel Status *</label>
                    <select id="vesselstatus" v-model="newContainer.vesselstatus" class="custom-select"
                        style="width:100%">
                        <option value="0">Select Status</option>
                        <option value="1">Balanced</option>
                        <option value="2">Complete</option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="vesselstatus">At Time (HHMM)</label>
                    <input type="text" id="txttime" v-model="newContainer.txttime" placeholder="0000"
                        v-on:blur="checkIsDate()" style="width:100%" />
                </div>
            </div>
            <div class="form-item">
                <button type="button" class="excel-button" @click="populate_data" :disabled="isSubmitting">SHOW</button>
                <button type="button" class="excel-button" @click="ova_report" :disabled="isSubmitting">Generate Report</button>
            </div>
            <div class="form-item">
                <div v-html="htmlContent"></div>
            </div>
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" @change="selectAll">
                            </th>
                            <th>
                                <span>Container</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('contnumber')"></i>
                            </th>
                            <th style="width:20px">
                                <span>ISO</span>
                            </th>
                            <th>
                                <span>Place</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('LocationName')"></i>
                            </th>
                            <th>
                                <span>Movement</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('MovementName')"></i>
                            </th>
                            <th>
                                <span>Date</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('inspDate')"></i>
                            </th>
                            <th>
                                <span>Seal No</span>
                                <i class="filter-icon fas fa-sort"></i>
                            </th>
                            <th>
                                <span>CFS</span>
                                <i class="filter-icon fas fa-sort"></i>
                            </th>
                            <th>
                                <span>Applicant</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('applicantname')"></i>
                            </th>
                            <th>
                                <span>Account</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('accountname')"></i>
                            </th>
                            <th>
                                <span>Vessel</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('VesselName')"></i>
                            </th>
                            <th>
                                <span>Voyage</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('VoyageName')"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(transaction) in transactions" :key="transaction.reportid">
                            <td>
                                <input type="checkbox" v-model="checkedIds" :value="transaction.reportid">
                            </td>

                            <td>{{ transaction.contnumber }}</td>
                            <td>{{ transaction.CType }}</td>
                            <td>{{ transaction.Name }}</td>
                            <td>{{ transaction.InspDate }}</td>
                            <td>{{ transaction.movementname }}</td>
                            <td>{{ transaction.Seal }}</td>
                            <td>{{ transaction.toplc }}</td>
                            <td>{{ transaction.applicantname }}</td>
                            <td>{{ transaction.accountname }}</td>
                            <td>{{ transaction.vessname }}</td>
                            <td>{{ transaction.voyagename }}</td>
                        </tr>
                        <tr>
                            <td>{{ contcount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            checkedIds: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            movementOptions: JSON.parse(localStorage.getItem('movements')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            location: JSON.parse(localStorage.getItem('locations')) || [],
            cfs_location: JSON.parse(localStorage.getItem('cfs_location')) || [],
            contcount: "",
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                applicantname: "",
                accountID: 0,
                accountname: "",
                vesselID: 0,
                VoyId: 0,
                movementID: 0,
                locID: 0,
                vesselstatus: "0",
                txttime: "",
                file: null,
                fromdate: '',
                todate: '',
            },
            htmlContent: null,
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        selectAll(event) {
            this.checkedIds = event.target.checked
                ? this.transactions.map(transaction => transaction.reportid)
                : [];
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.applicantname = AppAcc.applicantname
            this.newContainer.accountID = AppAcc.accountid
            this.newContainer.accountname = AppAcc.accountname
        },
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async populate_data() {
            if (this.isSubmitting) return;
            
            this.transactions = []
            this.checkedIds = []
            this.contcount = ""
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select a Party');
                return;
            }
            if (this.newContainer.movementID == 0) {
                useToast().error('Please select a movement');
                return;
            }
            if (this.newContainer.movementID == 3 || this.newContainer.movementID == 7 || this.newContainer.movementID == 17 || this.newContainer.movementID == 19) {
                if (this.newContainer.fromdate == '') {
                    if (this.newContainer.vesselID == 0) {
                        useToast().error('Please select a vessel');
                        return;
                    }
                    if (this.newContainer.VoyId == 0) {
                        useToast().error('Please select a voyage');
                        return;
                    }
                }
            }
            
            this.isSubmitting = true;
            
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName)
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                var fromDt = ''
                var toDt = ''
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate)
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate)
                }
                const response = await axios.get('/populate_general_excel?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&location=' + this.newContainer.locID + '&movement=' + this.newContainer.movementID + '&fromdate=' + fromDt + '&todate=' + toDt + '&vesselstatus=' + this.newContainer.vesselstatus, config);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = response.data[2];
                    this.contcount = response.data[3];
                }
            } catch (error) {
                console.error('Error populating data:', error);
                useToast().error(error.response?.data?.message || 'Error loading data.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async ova_report() {
            if (this.isSubmitting) return;
            
            const checkedIds = this.checkedIds;
            console.log(checkedIds)
            var vesselname = ""
            var voyahename = ""
            var movementname = ""
            var filename = ""
            var loc = ""
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select a Party');
                return;
            }
            if (this.newContainer.movementID == 0) {
                useToast().error('Please select a movement');
                return;
            }
            if (checkedIds == "") {
                useToast().error('Please select an Inspection');
                return;
            }
            if (this.newContainer.vesselstatus == 2) {
                if (this.newContainer.txttime == "") {
                    useToast().error("Please enter vessel complete time");
                    return;
                }
            }
            
            this.isSubmitting = true;
            
            try {
                if (this.newContainer.movementID != 0) {
                    movementname = this.movementOptions.find(v => v.Movid == this.newContainer.movementID).Name
                }
                if (this.newContainer.locID != 0) {
                    loc = this.location.find(v => v.locationid == this.newContainer.locID).Name
                }
                this.updateApplicantAccountIds(this.newContainer.partyName)
                filename = movementname + " " + this.newContainer.todate.replace(/\//g, "-") + ".xlsx"
                if (this.newContainer.movementID == 3 || this.newContainer.movementID == 7 || this.newContainer.movementID == 17 || this.newContainer.movementID == 19) {
                    if (this.newContainer.fromdate == '') {
                        if (this.newContainer.vesselID == 0) {
                            useToast().error('Please select a vessel');
                            return;
                        }
                        if (this.newContainer.VoyId == 0) {
                            useToast().error('Please select a voyage');
                            return;
                        }
                    }
                    if (this.newContainer.vesselID != 0) {
                        vesselname = this.vessel.find(v => v.Vesselid == this.newContainer.vesselID).Name
                    }
                    if (this.newContainer.VoyId != 0) {
                        voyahename = this.voyage.find(v => v.Voyageid == this.newContainer.VoyId).Name
                    }
                    if (this.newContainer.vesselID != 0) {
                        filename = vesselname + " " + voyahename + " " + movementname + " " + this.newContainer.todate.replace(/\//g, "-") + ".xlsx"
                    }
                }
                var mailsub = "GENERAL EXCEL REPORT " + movementname + " FOR " + this.newContainer.applicantname + " A/C " + this.newContainer.accountname
                var msgbody = "Dear All,<br /><br /> Please find report attached for " + movementname + " " + this.contcount
                if (this.newContainer.vesselstatus == 2) {
                    mailsub = "VESSEL COMPLETED " + vesselname + " " + voyahename + " " + loc + " FOR " + this.newContainer.applicantname + " A/C " + this.newContainer.accountname
                    msgbody = "Dear All,<br /><br /> Please find report attached for " + vesselname + " " + voyahename + " " + movementname + " " + this.newContainer.todate + " " + this.newContainer.txttime + " at " + loc + " " + this.contcount
                }
                else if (this.newContainer.vesselstatus == 1) {
                    mailsub = "VESSEL REPORT " + vesselname + " " + voyahename + " " + loc + " FOR " + this.newContainer.applicantname + " A/C " + this.newContainer.accountname
                    msgbody = "Dear All,<br /><br /> Please find report attached for " + vesselname + " " + voyahename + " " + movementname + " " + this.newContainer.todate + " " + this.newContainer.txttime + " at " + loc + " " + this.contcount + " (Balanced)"
                }
    
                this.updateApplicantAccountIds(this.newContainer.partyName)
    
                const qrydata = {
                    checkedIds: checkedIds,
                    applicantid: this.newContainer.applicantID,
                    accountid: this.newContainer.accountID,
                    filename: filename,
                    vesselstatus: this.newContainer.vesselstatus,
                    mailsub: mailsub,
                    msgbody: msgbody,
                    contcnt: this.contcount
                }
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const data = new FormData();
                const transdt = JSON.stringify(qrydata)
                data.append('transaction', transdt)
                const response = await axios.post('/general_excel', data, config);
                useToast().success(response.data[1]);
                this.transactions = []
            } catch (error) {
                console.error('Error generating report:', error);
                useToast().error(error.response?.data?.message || 'Error generating report.');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>